export default function BBBEESection() {
  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            B-BBEE Skills Development
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            How SETA compliance and skills development training directly impact your B-BBEE scorecard rating
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          <div>
            <div className="card p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Skills Development Scorecard Points
              </h3>
              
              <div className="space-y-6">
                <div className="border-l-4 border-[#2D7F3E] pl-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    Skills Development Expenditure
                  </h4>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Target: 6% of leviable amount</span>
                    <span className="text-2xl font-bold text-[#2D7F3E]">20 Points</span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Spend on training for black employees and unemployed black people
                  </p>
                </div>

                <div className="border-l-4 border-amber-500 pl-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    Learnerships & Internships
                  </h4>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Target: 2.5% of total employees</span>
                    <span className="text-2xl font-bold text-amber-600">15 Points</span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Black people participating in learnerships and internships
                  </p>
                </div>

                <div className="border-l-4 border-green-800 pl-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    Skills Development for Unemployed
                  </h4>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Target: 2.5% of total employees</span>
                    <span className="text-2xl font-bold text-green-800">5 Points</span>
                  </div>
                  <p className="text-sm text-gray-500">
                    Training provided to unemployed black people
                  </p>
                </div>
              </div>

              <div className="mt-6 p-4 bg-[#2D7F3E] text-white rounded-lg text-center">
                <p className="text-xl font-bold">Total Available: 40 Points</p>
                <p className="text-sm text-green-100">Out of 100 total B-BBEE points</p>
              </div>
            </div>
          </div>

          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20professionals%20in%20training%20session%20with%20B-BBEE%20transformation%20focus%2C%20modern%20corporate%20training%20room%20with%20mixed%20demographics%2C%20skills%20development%20and%20empowerment%20theme%2C%20professional%20business%20environment%20with%20charts%20and%20learning%20materials&width=600&height=400&seq=bbbee-training&orientation=landscape"
              alt="B-BBEE Skills Development Training"
              className="w-full h-64 object-cover rounded-xl mb-6"
            />

            <div className="space-y-6">
              <div className="card p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  How Training Impacts Your B-BBEE Rating
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-arrow-up-line text-green-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Improves overall B-BBEE level certification</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-up-line text-green-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Enhances tender and procurement opportunities</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-up-line text-green-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Demonstrates commitment to transformation</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-up-line text-green-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Builds a skilled and diverse workforce</span>
                  </div>
                </div>
              </div>

              <div className="bg-[#2D7F3E] text-white p-6 rounded-xl">
                <h3 className="text-xl font-semibold mb-3">
                  We Support Your Transformation Goals
                </h3>
                <p className="text-green-100 mb-4">
                  Our training programmes are designed to maximise your B-BBEE points while developing essential skills in your workforce.
                </p>
                <ul className="space-y-2 text-green-100">
                  <li className="flex items-start">
                    <i className="ri-check-line mr-2 mt-1"></i>
                    <span>B-BBEE compliant training programmes</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line mr-2 mt-1"></i>
                    <span>Learnership and internship coordination</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line mr-2 mt-1"></i>
                    <span>Unemployed learner recruitment</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line mr-2 mt-1"></i>
                    <span>B-BBEE scorecard optimization</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#2D7F3E] to-green-600 text-white p-8 rounded-xl text-center">
          <h3 className="text-2xl font-bold mb-4">Maximise Your B-BBEE Impact</h3>
          <p className="text-xl text-green-100 mb-6 max-w-3xl mx-auto">
            Strategic skills development can significantly improve your B-BBEE level while building organisational capability
          </p>
          <button className="btn btn-white">
            Get B-BBEE Skills Development Strategy
          </button>
        </div>
      </div>
    </section>
  );
}